export default {
  free_menu_items: 'Gratis ontgrendeld',
  discount_badge: '{{value}} korting',
  available_at_badge: 'Beschikbaar {{schedule}}',
  restricted_tooltip: 'Beschikbaar {{schedule}} — wijzig de afhaaltijd hierboven om te bestellen.',
};
